import { render, staticRenderFns } from "./alertCertExpire.vue?vue&type=template&id=a000de70"
import script from "./alertCertExpire.vue?vue&type=script&lang=js"
export * from "./alertCertExpire.vue?vue&type=script&lang=js"
import style0 from "./alertCertExpire.vue?vue&type=style&index=0&id=a000de70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports